export const actionType = Object.freeze({
    RESET_STORE: 'funder-applicant.reset-store',
    FETCH_FUNDER_PROFILE_FORM: 'funder-applicant.init-funder-applicant-form',
    SET_FUNDER_APPLICANT_PROFILE: 'funder-applicant.set-funder-applicant-profile-form',
    UPDATE_FUNDER_APPLICANT_PROFILE: 'funder-applicant.update-applicant-profile',
    ACCEPT_FUNDER_APPLICANT_PROFILE: 'funder-applicant.accept-applicant-profile'
});
